<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="tableData"
      :columns="tableColumns"
      :edit-config="{ trigger: 'click', mode: 'row' }"
      :height="333"
      border
      :edit-rules="validRules"
    >
      <template v-slot:top>
        <div class="side-frame-success">
          <span class="side-frame-text">
            {{ $l('group_title_pay_statement_item') || '结算单费用明细' }}
          </span>
          <el-divider direction="vertical"></el-divider>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-danger"
            @click="removeCheckboxRow()"
          >
            <i class="el-icon-delete" />
            {{ $l('INDEX.btn_delete') || '删除' }}
          </b-button>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_delete') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:expense="{ row }">
        <expense-select
          v-model="row.expenseCode"
          filterable
          clearable
          :body="{ expenseBizType: 'B' }"
          @change="
            (value, item) => expenseChange({ val: { value, item }, row })
          "
        />
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import { add } from '@/libs/util.number.js'
export default {
  props: { statementData: { type: Array, default: () => [] } },
  data() {
    return {
      tableData: [],
      tableColumns: tableColumns(this),
      validRules: {
        expenseType: [
          {
            required: true,
            message: '请选择项目费用',
          },
        ],
      },
    }
  },
  async mounted() {
    if (!this.statementData || !this.statementData.length) return
    const data = this.statementData.map((item) => {
      const {
        shipmentPayStatementCode,
        shipmentContractNo: customsNo,
        currencyTotalAmount: currencyAmount,
        v_currencyTotalAmount: v_currencyAmount,
        custCode,
        custName,
        remark: expenseRemark,
      } = item
      return {
        shipmentPayStatementCode,
        currencyAmount,
        v_currencyAmount,
        custCode,
        custName,
        customsNo,
        expenseRemark,
      }
    })

    const $itemTable = this.$refs.itemTable
    const newRows = data.map(async (item) => {
      const { row } = await $itemTable.insertAt({ ...item }, -1)
      return row
    })
    await $itemTable.setActiveCell(await newRows[0], 'expenseType')
    this.subTotAmount()
  },
  methods: {
    async validate() {
      const data = this.getTableData()
      if (!data || !data.length) {
        this.$message({
          message: '费用明细不能为空',
          type: 'warning',
        })
        return false
      }
      const result = await this.$refs.itemTable.validate(true)
      return !result
    },
    getTableData() {
      const { fullData } = this.$refs.itemTable.getTableData()
      return fullData
    },
    async delRow(row) {
      this.$refs.itemTable.remove(row)
      this.subTotAmount()
    },
    async removeCheckboxRow() {
      await this.$refs.itemTable.removeCheckboxRow()
      this.subTotAmount()
    },
    subTotAmount() {
      const data = this.getTableData()
      const totAmount = data.reduce(
        (result, next) => add(result, next.currencyAmount),
        0
      )
      this.$emit('updateTotAmount', totAmount)
    },
    expenseChange({ val, row }) {
      const { item } = val || {}
      const { expenseCode, expenseName, expenseType, v_expenseType } =
        item || {}
      row.expenseCode = expenseCode
      row.expenseName = expenseName
      row.expenseType = expenseType
      row.v_expenseType = v_expenseType
    },
  },
}
</script>
